export const TOGGLE_AVAIL_MODAL = "app/AVAILABILITY/TOGGLE_AVAIL_MODAL";

export const FETCH_AVAIL = "app/AVAILABILITY/FETCH_AVAIL";
export const FETCH_AVAIL_SUCCESS = "app/AVAILABILITY/FETCH_AVAIL_SUCCESS";
export const FETCH_AVAIL_FAILURE = "app/AVAILABILITY/FETCH_AVAIL_FAILURE";

export const DELETE_DAYOFF = "app/AVAILABILITY/DELETE_DAYOFF";
export const DELETE_DAYOFF_SUCCESS = "app/AVAILABILITY/DELETE_DAYOFF_SUCCESS";
export const DELETE_DAYOFF_FAILURE = "app/AVAILABILITY/DELETE_DAYOFF_FAILURE";

export const ADD_DAYOFF = "app/AVAILABILITY/ADD_DAYOFF";
export const ADD_DAYOFF_SUCCESS = "app/AVAILABILITY/ADD_DAYOFF_SUCCESS";
export const ADD_DAYOFF_FAILURE = "app/AVAILABILITY/ADD_DAYOFF_FAILURE";
